import { useEffect, useState } from "react";
import { LifeBuoy, Phone, Mail, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function SupportNoticeModal() {
  const { user, setUser } = useAuth();
  const [info, setInfo] = useState({ phone: "", email: "" });
  const [checked, setChecked] = useState(false);
  const [saving, setSaving] = useState(false);

  const open = !!user && user.support_notice_ack === false;

  useEffect(() => {
    if (open) {
      api.get("/support/info").then((r) => setInfo(r.data)).catch(() => {});
    }
  }, [open]);

  if (!open) return null;

  const confirm = async () => {
    setSaving(true);
    try {
      await api.post("/support/ack-notice");
      setUser({ ...user, support_notice_ack: true });
    } catch (e) {
      setSaving(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm"
      data-testid="support-notice-modal"
    >
      <div className="animate-fade-up w-full max-w-md border border-border bg-card p-8">
        <div className="mb-5 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center bg-primary/15 text-primary">
            <LifeBuoy size={22} />
          </div>
          <h2 className="font-display text-xl font-bold tracking-tight">Coordonnées de votre support</h2>
        </div>

        <p className="mb-4 border-l-2 border-primary bg-primary/10 p-3 text-sm" data-testid="notice-email-hint">
          Vous avez reçu un e-mail de bienvenue. Vérifiez vos indésirables et ajoutez
          l'expéditeur à vos contacts.
        </p>

        <p className="mb-5 text-sm text-muted-foreground">
          Notez bien les coordonnées ci-dessous : c'est ainsi que vous pourrez joindre notre
          équipe support à tout moment.
        </p>

        <div className="mb-6 space-y-3">
          <div className="flex items-center gap-3 border border-border bg-background p-3" data-testid="notice-phone">
            <Phone size={18} className="text-primary" />
            <span className="text-sm font-medium">{info.phone || "+33 6 76 27 70 87"}</span>
          </div>
          <div className="flex items-center gap-3 border border-border bg-background p-3" data-testid="notice-email">
            <Mail size={18} className="text-primary" />
            <span className="text-sm font-medium">{info.email || "maelgrgr@gmail.com"}</span>
          </div>
        </div>

        <label className="mb-6 flex cursor-pointer items-start gap-3 text-sm">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            data-testid="notice-ack-checkbox"
            className="mt-0.5 h-4 w-4 accent-primary"
          />
          <span>J'ai noté les coordonnées</span>
        </label>

        <button
          onClick={confirm}
          disabled={!checked || saving}
          data-testid="notice-confirm-btn"
          className="flex w-full items-center justify-center gap-2 bg-primary px-4 py-3 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary/90 disabled:opacity-50"
        >
          {saving && <Loader2 size={16} className="animate-spin" />}
          Compris
        </button>
      </div>
    </div>
  );
}
